import FullIndex from '@/rebuild/materials/shared/performance_report/surf/FullIndex.vue';
import Overview from '@/rebuild/materials/shared/performance_report/surf/Overview.vue';
import MobOverview from '@/rebuild/materials/shared/performance_report/surf/MobOverview.vue';
import MobFull from '@/rebuild/materials/shared/performance_report/surf/MobFull.vue';
import { withProvider } from '@rebuild/hooks/useCompWithProvider';
import { provideCurrentContext } from '@rebuild/materials/shared/performance_report/context';

function useSelfContext() {
	provideCurrentContext();
}

export const componentMap = {
    full: withProvider(FullIndex, useSelfContext),
    overview: withProvider(Overview, useSelfContext),
    'mob-overview': withProvider(MobOverview, useSelfContext),
    'mob-full': withProvider(MobFull, useSelfContext),
};